
import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "choir.application.success.title",
    },
    description: {
        id: "choir.application.success.description",
    },
    close: {
        id: "general.close",
    },
});

export default messages;
